/**
 * Render-boundary translation for the engineer-facing alias "canonical" names
 * that the import detection summary carries (the lowercase lookup keys the
 * adapters bind on, e.g. `"recurring"`). The treasurer never sees the raw
 * canonical token — only the column header they typed (rendered verbatim) and
 * a plain-English phrase for the field it was read as. Mirrors the
 * `jurisdictionFormLabel` / `PreflightCopy` pattern: a small map + a passthrough
 * fallback so an unmapped canonical degrades to its own (already human-ish)
 * name rather than throwing.
 */
// Exported so a snapshot test can pin the byte-for-byte literals without
// coupling to the lookup helper (mirrors JURISDICTION_FORM_LABEL_MAPPINGS).
export const ALIAS_CANONICAL_LABELS: Record<string, string> = {
  recurring: 'the recurring-donation flag',
  'payment method': 'payment method',
  org: 'organization-donor type',
  'organization name': 'organization-donor type',
};

/**
 * Translate an alias-resolution canonical lookup name to treasurer-first copy.
 * Case-insensitive, trimmed. Unmapped canonicals pass through unchanged
 * (never empty) — `"address"`, `"zip"`, etc. are already words the treasurer
 * recognizes.
 */
export function aliasCanonicalLabel(canonical: string): string {
  const key = canonical.trim().toLowerCase();
  return ALIAS_CANONICAL_LABELS[key] ?? canonical;
}
